// src/components/ui/Button.tsx
import React from 'react';
import { Button as MUIButton, ButtonProps } from '@mui/material';

const Button: React.FC<ButtonProps> = (props) => {
  return <MUIButton {...props} sx={{...props.sx ,height: "42px"}}/>;
};

export default Button;